import { FeatureFlag } from '@ps/web-core-enums';
import { type Modal, useFeature } from '@ps/web-core-store';
import React from 'react';
import Loadable from 'react-loadable';
import { useSelector } from 'react-redux';
import { MemoryRouter, Route } from 'react-router';

import useInactivityTimeout from '@swf/core/hooks/useInactivityTimeout';
import { select } from '@swf/core/store';
import { FirstLoader, InactivityTimeoutPrompt, SignupWizard } from '@swf/first';

import ModalRoute from './ModalRoute';

const LoadableStarsModal = Loadable({
  loader: () => import('../../swf-components/StarsModal/StarsModal'),
  loading: () => null,
  render: ({ default: StarsModal }) => <StarsModal />
});

const SignupRoute: React.FC = () => {
  const SWCSignup = useFeature(FeatureFlag.SwcSignup);
  const isSWCEmailVerificationEnabled = useFeature(FeatureFlag.SwcEmailVerification);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const bankID = useFeature(FeatureFlag.BankID);
  const signupPath = `/auth/registration${bankID ? '/bankid' : ''}`;
  const hasClientSession = useSelector(select.session.hasClientSession);
  const { path, locationState } = (useSelector(select.modal.getCurrent) || {}) as Partial<Modal>;
  const { showInactivityPrompt, remainingSeconds, setShowInactivityPrompt } =
    useInactivityTimeout();

  return SWCSignup ? (
    <>
      <MemoryRouter
        keyLength={process.env.NODE_ENV === 'test' ? 0 : 6}
        initialEntries={[{ pathname: path, state: locationState }]}
      >
        {showInactivityPrompt && (
          <Route
            render={() => (
              <InactivityTimeoutPrompt
                remainingSeconds={remainingSeconds}
                onClose={() => setShowInactivityPrompt(false)}
              />
            )}
          />
        )}
        {!hasClientSession ? <FirstLoader /> : React.createElement(SignupWizard)}
      </MemoryRouter>
      {isSWCEmailVerificationEnabled && !isEmbedded && <LoadableStarsModal />}
    </>
  ) : (
    <ModalRoute modal={{ path: signupPath }} />
  );
};

export default SignupRoute;
